import { Info } from "lucide-react";

export const OWNERSHIP_DISCLAIMER =
  "This note is for informational purposes only. I claim no ownership or authorship of its contents; all rights belong to their respective original owners.";

export default function OwnershipDisclaimer({ product }) {
  if (!product?.no_ownership_claim) return null;
  return (
    <p
      data-testid={`ownership-disclaimer-${product.product_id}`}
      className="flex items-start gap-1.5 text-[10px] leading-snug italic text-[#6B7280]"
    >
      <Info className="h-3 w-3 shrink-0 mt-px" />
      <span>{OWNERSHIP_DISCLAIMER}</span>
    </p>
  );
}
